import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as tmxActions from '../Actions/tmxActions';
import TmxUploadForm from "../Components/Tmx/TmxUploadForm";
import { tmxService } from "../Services/TmxService.js";
import { withRouter } from 'react-router';
import { languageService } from "../Services/LanguageService.js";

class TmxUploadFormContainer extends Component {
	constructor(props){
		super(props);
		this.state={
			langPairs: []
		};
		this.uploadTmx = this.uploadTmx.bind(this);
	}
	
	componentDidMount() {
		languageService.getLangiuagePairs()
			.then(response => {let list=response.data; return this.setState({ langPairs: list.sort(function(a, b) { return (a.code > b.code) ? 1 : ((a.code < b.code) ? -1 : 0);}) });;})
			.catch(err => {/*console.log(err);*/});
	}
	
	uploadTmx(tmx, description, langPairId) {
		tmxService.uploadTmx(tmx, langPairId, description)
			.then(() => {return this.props.history.push('/tmxList');})
			.catch(err => {/*console.log(err);*/});
	}
	
	render() {
//		console.log("[TmxFormContainer.render()] this.props.tmx: "+JSON.stringify(this.props.tmx));
	    return (<div className="content">
					<TmxUploadForm
						tmx={0}
						langPairs={this.state.langPairs}
						uploadTmx={this.uploadTmx}
					/>
				</div>);
	}
}

function mapStateToProps(state, ownProps) {  
//	console.log('mapStateToProps [TmxFormContainer]: '+JSON.stringify(ownProps));
	return {user: state.user}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(tmxActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(TmxUploadFormContainer);  